/* GG cart bulk pricing + free-shipping bar (2026-10-27, preview theme only).
   Source of truth: the Dr Stacked Discounts app's own /apps/discount-on-cart-pro/cart-summary response
   (same engine that draws the under-subtotal DOCAPP lines and the "You are $X away from FREE SHIPPING!" text).
   - Per line: discounted unit + line total from summary.cart.items, full price crossed out (PDP .sale/.current_price/.was_price classes).
   - Subscription (selling plan) lines are never given bulk pricing.
   - Free-shipping bar: "away" amount is read from the app's .docapp-free-shipping-promo; threshold = app est. total + away. */
(function () {
  if (window.__ggCartBulk) return; window.__ggCartBulk = 1;
  var SUMMARY_URL = '/apps/discount-on-cart-pro/cart-summary';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var last = null, timer = null, seq = 0, applying = false;
  var MSG_DONE = 'Yippee! You\u2019ve unlocked FREE SHIPPING! \uD83C\uDF89';

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  var _fetch = window.fetch ? window.fetch.bind(window) : null;
  function getJSON(url, body) {
    var o = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return _fetch(url, o).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var my = ++seq;
      getJSON('/cart.js').then(function (cart) {
        if (!cart.item_count) return { cart: cart, summary: null };
        return getJSON(SUMMARY_URL, { cart: cart }).then(function (s) { return { cart: cart, summary: s }; },
                                                          function () { return { cart: cart, summary: null }; });
      }).then(function (d) { if (my !== seq) return; last = d; apply(); }).catch(function () {});
    }, delay == null ? 250 : delay);
  }

  /* ---------- per-line bulk pricing ---------- */
  function lineData(idx) {
    if (!last || !last.summary || !last.summary.cart) return null;
    var c = last.cart.items[idx], s = last.summary.cart.items[idx];
    if (!c || !s || String(c.variant_id) !== String(s.variant_id) || c.quantity !== s.quantity) return null;
    if (c.selling_plan_allocation) return null;                      // Subscribe & Save: no bulk price
    if (!(s.final_line_price < s.original_line_price)) return null;  // no tier reached
    var tier = '';
    try {
      var bd = (last.summary.cart_discounts_breakdown || {}).discounts || [];
      for (var i = 0; i < bd.length; i++) if (bd[i].key === c.key && bd[i].discounts && bd[i].discounts[0]) tier = bd[i].discounts[0].title || '';
    } catch (e) {}
    var pct = Math.round((1 - s.final_line_price / s.original_line_price) * 100);
    return { qty: s.quantity, unit: (s.final_price != null ? s.final_price : s.final_line_price / s.quantity), full: s.original_price, line: s.final_line_price, fullLine: s.original_line_price, pct: pct, tier: tier };
  }

  function priceHTML(now, was) {
    return '<span class="sale"><span class="current_price"><span class="money">' + money(now) + '</span></span></span> ' +
           '<span class="was_price"><span class="money">' + money(was) + '</span></span>';
  }

  function decorate(row, idx, unitHost, totalHost) {
    var d = lineData(idx);
    var key = d ? [d.unit, d.full, d.line, d.pct].join('|') : '';
    if (row.getAttribute('data-gg-bulk') === key) return;
    row.setAttribute('data-gg-bulk', key);
    [unitHost, totalHost].forEach(function (h) {
      if (!h) return;
      var old = h.parentNode && h.parentNode.querySelector(':scope > .gg-bulk-price[data-for="' + h.className.split(' ')[0] + '"]');
      if (old) old.remove();
      h.classList.remove('gg-bulk-hidden');
    });
    row.classList.toggle('gg-bulk-line', !!d);
    if (!d) return;
    if (unitHost) {
      var u = el('p', 'modal_price gg-bulk-price', priceHTML(d.unit, d.full) +
        ' <span class="gg-bulk-tag">Bulk ' + d.pct + '% off</span>');
      u.setAttribute('data-for', unitHost.className.split(' ')[0]);
      u.setAttribute('aria-label', 'Bulk price ' + money(d.unit) + ' each, was ' + money(d.full) + ', ' + d.pct + ' percent off');
      unitHost.classList.add('gg-bulk-hidden'); unitHost.parentNode.insertBefore(u, unitHost.nextSibling);
    }
    if (totalHost) {
      var t = el('p', 'price_total gg-bulk-price', '<strong>Total:</strong> ' + priceHTML(d.line, d.fullLine));
      t.setAttribute('data-for', totalHost.className.split(' ')[0]);
      totalHost.classList.add('gg-bulk-hidden'); totalHost.parentNode.insertBefore(t, totalHost.nextSibling);
    }
  }

  function applyLines() {
    // /cart page lines
    document.querySelectorAll('[data-cart-form="cart-template"] .cart__item[data-cart-item]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-line-id'), 10) - 1;
      decorate(row, idx, row.querySelector(':scope .cart__item--content > p.modal_price:not(.gg-bulk-price)'),
                         row.querySelector(':scope .cart__item--content > p.price_total:not(.gg-bulk-price)'));
    });
    // mini cart (drawer / dropdown) lines
    document.querySelectorAll('[data-cart-form="mini-cart"] .mini-cart__item[data-cart-item]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-line-id'), 10) - 1;
      var host = row.querySelector('.mini-cart__item--content strong.price:not(.gg-bulk-price)');
      var d = lineData(idx), key = d && host ? [d.unit, d.full, d.line].join('|') : '';
      if (row.getAttribute('data-gg-bulk') === key) return;
      row.setAttribute('data-gg-bulk', key);
      var old = row.querySelector('.gg-bulk-price'); if (old) old.remove();
      if (host) host.classList.remove('gg-bulk-hidden');
      row.classList.toggle('gg-bulk-line', !!d);
      if (!d || !host) return;
      var n = el('div', 'gg-bulk-price gg-bulk-mini', '<span class="modal_price">' + priceHTML(d.unit, d.full) + '</span>' +
        '<span class="gg-bulk-mini__line">Bulk ' + d.pct + '% off \u00B7 ' + d.qty + ' = <strong>' + money(d.line) + '</strong></span>');
      host.classList.add('gg-bulk-hidden'); host.parentNode.insertBefore(n, host.nextSibling);
    });
  }


  /* Bulk discount still to come off at checkout = theme subtotal (already net of Shopify automatic
     discounts, e.g. the Halloween sale) minus the app's EST. TOTAL. The app's auto_discount_amount also
     includes those Shopify discounts, so using it directly would count them twice. */
  function bulkDisc() {
    var s = last && last.summary; if (!s || !last.cart) return 0;
    if (s.estimated_total != null) return Math.max(0, last.cart.total_price - s.estimated_total);
    return (s.auto_discount_amount || 0) + (s.discount_amount || 0);
  }

  /* ---------- mini-cart totals (no DOCAPP widget there) ---------- */
  function applyMiniTotals() {
    var s = last && last.summary, disc = bulkDisc();
    document.querySelectorAll('[data-cart-form="mini-cart"]').forEach(function (form) {
      var sub = form.querySelector('li.cart_subtotal'); if (!sub) return;
      var box = form.querySelector('li.gg-bulk-mini-totals');
      if (!(disc > 0)) { if (box) box.remove(); return; }
      var html = '<span class="gg-row sale"><span>Bulk discount</span><span>-' + money(disc) + '</span></span>' +
                 '<span class="gg-row gg-est"><span>Est. total</span><span>' + money(s.estimated_total) + '</span></span>';
      if (!box) { box = el('li', 'gg-bulk-mini-totals'); sub.parentNode.insertBefore(box, sub.nextSibling); }
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }


  /* ---------- theme "Total Savings" = compare-at savings only; add the bulk discount so the number is true ---------- */
  function cents(txt) { var m = String(txt).replace(/[^0-9.]/g, ''); return m ? Math.round(parseFloat(m) * 100) : 0; }
  function applySavings() {
    var s = last && last.summary, disc = bulkDisc();
    document.querySelectorAll('.cart_savings').forEach(function (box) {
      var span = box.querySelector('.money'); if (!span) return;
      var cur = span.textContent.trim();
      if (span.getAttribute('data-gg-out') !== cur) span.setAttribute('data-gg-base', cents(cur));
      var base = +span.getAttribute('data-gg-base') || 0, note = box.querySelector('.gg-savings-note');
      if (disc > 0 && base > 0) {
        var out = money(base + disc);
        if (cur !== out) { span.textContent = out; }
        span.setAttribute('data-gg-out', out);
        var nh = 'Sale prices ' + money(base) + ' + bulk discount ' + money(disc);
        if (!note) { note = el('span', 'gg-savings-note'); box.appendChild(note); }
        if (note.textContent !== nh) note.textContent = nh;
      } else {
        if (span.getAttribute('data-gg-out') === cur && base) { span.textContent = money(base); }
        span.removeAttribute('data-gg-out');
        if (note) note.remove();
      }
    });
  }

  /* ---------- free-shipping progress bar ---------- */
  function shipState() {
    if (!last || !last.cart || !last.cart.item_count || !last.summary) return null;
    var s = last.summary, total = s.estimated_total != null ? s.estimated_total : last.cart.total_price, away = null;
    var m = /docapp-free-shipping-promo[\s\S]*?data-geolizr-price="(\d+)"/.exec(s.cart_summary_html || '');
    if (m) away = parseInt(m[1], 10);
    var thr = away != null ? total + away : parseInt(sessionStorage.getItem('gg_fs_thr') || '5000', 10);
    if (away != null) try { sessionStorage.setItem('gg_fs_thr', String(thr)); } catch (e) {}
    if (away == null && total < thr) return null;   // app shows no free-shipping message: don't invent one
    return { total: total, thr: thr, away: away == null ? 0 : away };
  }
  function shipbarHTML(st) {
    var done = st.away <= 0, pct = done ? 100 : Math.max(0, Math.min(100, Math.round(st.total / st.thr * 100)));
    var msg = done ? MSG_DONE : 'You are <strong>' + money(st.away) + '</strong> away from FREE SHIPPING!';
    return { pct: pct, done: done, msg: msg };
  }
  function renderBar(host, st) {
    var bar = host.querySelector(':scope > .gg-shipbar');
    if (!st) { host.classList.add('gg-shipbar-empty'); if (bar) bar.hidden = true; return; }
    host.classList.remove('gg-shipbar-empty');
    var v = shipbarHTML(st);
    if (!bar) {
      bar = el('div', 'gg-shipbar',
        '<p class="gg-shipbar__msg" aria-live="polite"></p>' +
        '<div class="gg-shipbar__track" role="progressbar" aria-valuemin="0" aria-label="Progress to free shipping"><div class="gg-shipbar__fill"></div></div>');
      host.appendChild(bar);
    }
    bar.hidden = false;
    bar.classList.toggle('is-done', v.done);
    var msg = bar.querySelector('.gg-shipbar__msg'); if (msg.innerHTML !== v.msg) msg.innerHTML = v.msg;
    var tr = bar.querySelector('.gg-shipbar__track');
    tr.setAttribute('aria-valuemax', (st.thr / 100).toFixed(2));
    tr.setAttribute('aria-valuenow', (Math.min(st.total, st.thr) / 100).toFixed(2));
    tr.setAttribute('aria-valuetext', v.done ? 'Free shipping unlocked' : money(st.away) + ' to go, ' + v.pct + ' percent');
    bar.querySelector('.gg-shipbar__fill').style.width = v.pct + '%';
  }
  function applyShipbar() {
    var st = shipState();
    document.documentElement.classList.toggle('gg-shipbar-on', !!st);
    document.querySelectorAll('[data-gg-shipbar]').forEach(function (h) { renderBar(h, st); });
    document.querySelectorAll('[data-cart-form="mini-cart"]').forEach(function (form) {
      var anchor = form.querySelector('li.gg-bulk-mini-totals') || form.querySelector('li.cart_subtotal'); if (!anchor) return;
      var h = form.querySelector('li[data-gg-shipbar-mini]');
      if (!h) { h = el('li', 'gg-shipbar-host gg-shipbar-host--mini'); h.setAttribute('data-gg-shipbar-mini', ''); }
      if (h.previousSibling !== anchor) anchor.parentNode.insertBefore(h, anchor.nextSibling);
      renderBar(h, st);
    });
  }

  function apply() {
    if (applying) return; applying = true;
    try { applyLines(); applyMiniTotals(); applySavings(); applyShipbar(); sizeMini(); } finally { applying = false; }
  }


  /* ---------- size the open mini cart to the visible viewport (item list scrolls, footer stays) ---------- */
  function sizeMini() {
    document.querySelectorAll('.cart_container .cart_content').forEach(function (cc) {
      var r = cc.getBoundingClientRect(); if (!r.height && !r.width) return;
      var v = Math.max(280, Math.floor((window.visualViewport ? window.visualViewport.height : window.innerHeight) - Math.max(0, r.top) - 8)) + 'px';
      if (cc.style.getPropertyValue('--gg-mc-max') !== v) cc.style.setProperty('--gg-mc-max', v);
    });
  }
  function sizeSoon() { sizeMini(); setTimeout(sizeMini, 60); setTimeout(sizeMini, 350); }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.cart_container, a.mini_cart')) sizeSoon(); }, true);
  document.addEventListener('mouseover', function (e) { if (e.target.closest && e.target.closest('.cart_container')) sizeMini(); }, true);
  window.addEventListener('resize', sizeMini);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', sizeMini);

  /* ---------- triggers: cart AJAX (fetch + XHR), DOM re-renders, page show ---------- */
  if (_fetch) window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (CART_RE.test(url)) p.then(function () { refresh(); }, function () {});
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', function () { refresh(); });
    return _open.apply(this, arguments);
  };
  var mo = new MutationObserver(function () { if (!applying && last) { clearTimeout(mo.t); mo.t = setTimeout(apply, 60); } });
  function start() {
    document.querySelectorAll('[data-cart-form], .subtotal').forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); });
    // the theme replaces the whole mini-cart list on update; watch its containers too
    document.querySelectorAll('.cart_container').forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); });
    refresh(0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(0); });
  window.ggCartBulkRefresh = refresh;
})();
